import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestAprvsGetRes } from "./abst/DtoRequestAprvsGetRes";

export class DtoRequestAprvsGetResImple extends DtoRequestAprvsGetRes {
  public request = new EntityRequest();

  public pager = new DtoApiPager();
}
